import { render, staticRenderFns } from "./CheeseExchange.vue?vue&type=template&id=d2bc83fa&"
import script from "./CheeseExchange.vue?vue&type=script&lang=js&"
export * from "./CheeseExchange.vue?vue&type=script&lang=js&"
import style0 from "./CheeseExchange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports